import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import { IWarehouseStateCodes } from '../../models/warehouse/warehouse.model';
import useHttps from '../useHttps';

const useListState = () => {
  const request = useHttps();
  const [stateListLoading, setStateListLoading] = useState(false);
  const [listOfState, setListOfState] = useState<any>();

  useEffect(() => {
    const getState = () => {
      const url: HttpConfig = {
        url: 'general-service/v1/commons/states',
        method: 'get',
      };

      request(url, onListStateSuccess, setStateListLoading, onListStateError);
    };
    getState();
  }, [request]);

  const onListStateError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const onListStateSuccess = ({
    message,
    data,
  }: SuccessHttpResponse<IWarehouseStateCodes[]>) => {
    setListOfState(data);
    // toast.success(message);
  };

  return { listOfState, stateListLoading };
};

export default useListState;
